module.exports = __webpack_public_path__ + "img/dsci0022.86ae4ca0.jpg";